import React, { useState, useContext } from 'react';
import { API_URL } from '../../constants';

import './EIMP.css';

import { LoadingButton } from '@mui/lab';
import Stack from '@mui/material/Stack';
import { TabContext } from '../home/TabProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Radio, TextField, Container } from '@mui/material';
import Swal from "sweetalert2";

const EIMP = () => {

  const { sharedData, setSharedData } = useContext(TabContext);
  const [firstName, setFirstName] = useState(sharedData.eimpData?.firstName || '');
  const [lastName, setLastName] = useState(sharedData.eimpData?.lastName || '');
  const [dob, setDob] = useState(sharedData.eimpData?.dob || null);
  const [email, setEmail] = useState(sharedData.eimpData?.email || '');
  const [phone, setPhone] = useState(sharedData.eimpData?.phone || '');
  const [uhgIdentifier, setUhgIdentifier] = useState(sharedData.eimpData?.uhgIdentifier || '');

  const [eimpJSONObject, setEimpJSONObject] = useState(sharedData.eimpJSONObject || {});
  const [eimpLoading, setEimpLoading] = useState(false);
  const [hsidLoading, setHsidLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(0);
  const [file, setFile] = useState(null);

  const handleFileUpload = () => {
    const formData = new FormData();
    const fileInput = document.getElementById('file-upload');
    if (fileInput.files.length === 0) {
      Swal.fire({
        title: 'Error',
        text: 'Please select a file to upload',
        icon: 'error'
      });
      return;
    }
    formData.append('file', fileInput.files[0]);
    
    fetch(API_URL + '/eimp/process-csv', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      Swal.fire({
        title: 'Success',
        text: 'File processed successfully',
        icon: 'success'
      });
    })
    .catch(error => {
      console.error('Error:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to process file',
        icon: 'error'
      });
    });
  };
  const eimpLookup = () => {
    setEimpLoading(true);
    setEimpJSONObject({});
    const errorDiv = document.getElementById('eimp-error');
    if (errorDiv) {
      errorDiv.remove();
    }
    const requestData = {
      firstName,
      lastName,
      dob: dob?.format('YYYY-MM-DD'),
      email,
      phone,
      uhgIdentifier
    };
    
    fetch(API_URL + '/eimp/search', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.message?.error) {
        Swal.fire({
          html: data.message.error
        })
        setEimpLoading(false);
      }
      else {
        setEimpJSONObject(data);
        setEimpLoading(false);
        setSharedData({ eimpJSONObject: data, eimpData: getUserInfoFromEIMPRecord(data[0]) });
      }
    })
    .catch(error => {
      setEimpLoading(false);
      console.error('Error:', error);
      // Handle the error in your UI
    });
  };

  const getUserInfoFromEIMPRecord = (data) => {

    let enterpriseid, firstName, lastName, hsid, address, dob, primaryEmail, phone;
    if (data.givenName) firstName = data.givenName;
    if (data.familyName) lastName = data.familyName;
    if (data.birthDate) dob = data.birthDate;

    if (data.identifiers) {
      if (data.identifiers.identity_enterpriseId && data.identifiers.identity_enterpriseId[0])
        enterpriseid = data.identifiers.identity_enterpriseId[0].enterpriseID;
      if (data.identifiers.identity_enterpriseId && data.identifiers.hsid_identifiers[0])
        hsid = data.identifiers.hsid_identifiers[0].hsid;

      primaryEmail = data.contacts?.emails?.length > 0 ? data.contacts.emails.find(email => email.type === "Primary Email").email : '';
      phone = data.contacts?.telephoneNumbers?.length > 0 ? data.contacts?.telephoneNumbers?.find(phone => phone.preferredIndicator === "true")?.number : '';
    }

    if (data.contacts) {
      address = data.contacts?.postalAddresses?.length > 0 ? data.contacts?.postalAddresses.find(address => address.type === "Primary Residence") : data.contacts?.postalAddresses[0];
    }
    return { enterpriseid, firstName, lastName, hsid, address, dob, email: primaryEmail, phone };
  }

  const hsidLookup = () => {
    setHsidLoading(true);
    console.log('hsidLookup'); 
  };

  const selectEIMPUserHanlder = (event) => {
    const value = event.target.value;
    setSharedData({ ...sharedData,eimpJSONObject: eimpJSONObject, eimpData: getUserInfoFromEIMPRecord(eimpJSONObject[value]) });
    setSelectedValue(value);
  };

  return (
    <Container className="container">
      <Stack spacing={2}>
        <TextField
            className="textField"
            label="First Name"
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
        />
        <TextField
            className="textField"
            label="Last Name"
            value={lastName}
            onChange={(event) => setLastName(event.target.value)} />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
              className="textField"
              label="Date of Birth"
              value={dob}
              onChange={value => setDob(value)} />
        </LocalizationProvider>
          <TextField
            className="textField"
            label="Email"
            value={email}
            onChange={(event) => setEmail(event.target.value)} />
          <TextField
            className="textField"
            label="Phone #:"
            value={phone}
            onChange={(event) => setPhone(event.target.value)} />
          <TextField
            className="textField"
            label="UHG Identifier:"
            value={uhgIdentifier}
            onChange={(event) => setUhgIdentifier(event.target.value)} />        
          <Stack direction="row" spacing={2}>
            <LoadingButton 
              size="small"
              loading={eimpLoading} 
              onClick={eimpLookup}
              loadingPosition="center"
              variant="contained">
                EIMP Lookup
            </LoadingButton>
            <LoadingButton 
              size="small"
              loading={hsidLoading} 
              onClick={hsidLookup}
              loadingPosition="center"
              variant="contained">
                HSID Lookup
            </LoadingButton>
          </Stack>
          <Stack direction="row" spacing={2} alignItems="center">
             <div style={{ margin: '20px' }}>
                <input
                  type="file"
                  accept=".csv"
                  style={{ display: 'block' }}
                  id="file-upload"
                />
                <label>
                  <LoadingButton
                    variant="contained"
                    component="span"
                    onClick={handleFileUpload}
                    style={{ marginTop: '10px' }}
                  >
                    Upload CSV File
                  </LoadingButton>
                </label>
              </div>
          </Stack>
        </Stack>
        <div style={{ marginBottom: '20px' }}></div>
      {eimpJSONObject && eimpJSONObject.length >= 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
              {eimpJSONObject && eimpJSONObject.length > 1 && (<TableCell>Select</TableCell>)}
                <TableCell>Enterprise ID</TableCell>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>HSID</TableCell>
                <TableCell>Street</TableCell>
                <TableCell>City</TableCell>
                <TableCell>State</TableCell>
                <TableCell>Zip</TableCell>
                <TableCell>DOB</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(eimpJSONObject).map((key) => {
                const userInfo = getUserInfoFromEIMPRecord(eimpJSONObject[key]);
                return (
                  <TableRow key={key}>
                    {eimpJSONObject && eimpJSONObject.length > 1 && (
                      <Radio checked={selectedValue === key}
                      onChange={selectEIMPUserHanlder}
                      value={key}
                      name="radio-buttons" />
                    )}
                    <TableCell>{userInfo.enterpriseid}</TableCell>
                    <TableCell>{userInfo.firstName}</TableCell>
                    <TableCell>{userInfo.lastName}</TableCell>
                    <TableCell>{userInfo.hsid}</TableCell>
                    <TableCell>{userInfo.address.addressLineOne}</TableCell>
                    <TableCell>{userInfo.address.city}</TableCell>
                    <TableCell>{userInfo.address.provinceState}</TableCell>
                    <TableCell>{userInfo.address.zipPostalCode}</TableCell>
                    <TableCell>{userInfo.dob}</TableCell>
                    <TableCell>{userInfo.email}</TableCell>
                    <TableCell>{userInfo.phone}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default EIMP;